import { render } from "./time-stamp.vue?vue&type=template&id=146cb508&scoped=true"
import script from "./time-stamp.vue?vue&type=script&lang=js"
export * from "./time-stamp.vue?vue&type=script&lang=js"

import "./time-stamp.vue?vue&type=style&index=0&id=146cb508&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146cb508"]])

export default __exports__